import MonthKaoHe from 'branchComponent/page/MonthKaoHe.vue'; // 月考核
import MonthZhiChi from 'branchComponent/page/MonthZhiChi.vue'; // 月考核应支持
// import publicSingleObjectePage from '../../component/lining/page/publicSingleObjectePage'; // 单对象公共页面

import dataKanban from 'branchComponent/page/dataKanban.vue'; // 数据看板
import promactiQueryList from 'branchComponent/page/promactiQueryList.vue'; // 测试
import custReport from 'branchComponent/page/custReport.vue'; // 数据看板(客户)
import storeReport from 'branchComponent/page/storeReport.vue'; // 数据看板(店铺)

import bulkUpdate from 'branchComponent/page/channelCenter/bulkUpdate';

import attaUpload from 'branchComponent/page/attaUpload.vue';
import forwardUpload from 'branchComponent/page/forwardUpload.vue';
import propChangeUpload from 'branchComponent/page/propChangeUpload.vue'; // 道具变更附件定制
import unifiedTask from 'branchComponent/page/unifiedTask.vue';

export default {
  MonthKaoHe: {
    component: MonthKaoHe
  },
  MonthZhiChi: {
    component: MonthZhiChi
  },
  // publicSingleObjectePage: { // 单对象公共页面
  //   component: publicSingleObjectePage
  // },
  dataKanban: { // 数据看板 暂用促销活动页面
    component: dataKanban // dataKanban testTabsComponents
  },
  promactiQueryList: {
    component: promactiQueryList // 促销
  },
  custReport: {
    component: custReport
  },
  storeReport: {
    component: storeReport
  },
  bulkUpdate: {
    component: bulkUpdate,
    labelName: '批量更新'
  },
  attaUpload: {
    component: attaUpload
  },
  forwardUpload: {
    component: forwardUpload
  },
  propChangeUpload: {
    component: propChangeUpload
  },
  unifiedTask: {
    component: unifiedTask
  }
};